export default __webpack_public_path__ + "static/media/404.08ed304f.png";